import {Button, useNotifications} from "@twigsby/frontend-framework";
import {useContext, useEffect} from "react";
import {authConfig, useUKPBAuth} from "../../Providers/AuthProvider";
import {AuthContext} from "react-oauth2-code-pkce";
import {useLocation} from "react-router-dom";
import { faBug } from '@fortawesome/pro-solid-svg-icons/faBug';

const Login = (props: any) => {
    const {
        token,
        error,
        loginInProgress,
    } = useContext(AuthContext);

    const { LogIn, LogOut, loggingOut } = useUKPBAuth();

    const location = useLocation();

    const { addNotification } = useNotifications();

    const HandleAuthIssue = (error: any) => {
        addNotification({
            title: `Authorisation: ${error.toString()}`,
            icon: faBug
        });
        LogOut();
    }

    useEffect(() => {
        if(!loggingOut.current && !token && !loginInProgress) {
           // LogIn();
        }
    }, []);

    useEffect(() => {
        if(error) {
            HandleAuthIssue(error);
        }
    }, [error]);

    return (
        <>
            <div className='p-xl'>
                <h1>Sign In</h1>

                <p style={{ whiteSpace: 'pre'}}>CONFIG: {JSON.stringify(authConfig, null, 4)}</p>

                <p style={{ whiteSpace: 'pre'}}>LOCATION: {JSON.stringify(location, null, 4)}</p>

                {loginInProgress && (
                    <h2>Authorising</h2>
                )}

                {error && (
                    <>
                        <p>An error occurred during authentication: {error}</p>
                        <Button title={'Logout'} onClick={() => LogOut()} />
                    </>
                )}

                {!token && (
                    <Button title={'Login'} onClick={() => LogIn()} />
                )}

                {token && (
                    <Button title={'Logout'} onClick={() => LogOut()} />
                )}

                <h5>AUTH DATA:</h5>
                <div>
                    <p>TOKEN: {JSON.stringify(token, null, 2)}</p>
                </div>

            </div>
        </>
    )
}

export default Login
